export const PLATE_CHASSIS_STATUS = Object.freeze({
  PENDING: 'pending',
  ERROR: 'error',
  OK: 'ok',
  MISMATCH: 'mismatch',
});
